module.exports = __webpack_public_path__ + "img/607fd7e.png";